import { Colors } from '@/styles/colors';

const steps = [
  {
    title: 'Pilih algoritma',
    body: 'Mulai dari Bubble Sort atau Insertion Sort jika baru belajar, lalu bandingkan dengan Merge Sort atau Quick Sort.',
  },
  {
    title: 'Pilih jenis data',
    body: 'Coba data acak, sudah urut, terbalik, atau banyak duplikat untuk melihat kenapa performa bisa berubah.',
  },
  {
    title: 'Jalankan visualisasi',
    body: 'Tekan Play untuk memutar otomatis, atau gunakan tombol langkah untuk maju dan mundur secara perlahan.',
  },
  {
    title: 'Baca hasilnya',
    body: 'Perhatikan warna batang, jumlah perbandingan, pertukaran, dan pseudocode agar prosesnya lebih mudah dipahami.',
  },
];

const faqs = [
  {
    question: 'Website ini dibuat untuk apa?',
    answer: 'SortLab dibuat sebagai alat belajar visual. Fokusnya bukan hanya hasil akhir, tetapi proses bagaimana data berpindah sampai tersusun.',
  },
  {
    question: 'Apa arti warna pada batang?',
    answer: 'Warna menunjukkan status data: sedang dibandingkan, ditukar, dipilih sebagai pivot, atau sudah selesai diurutkan.',
  },
  {
    question: 'Kenapa jumlah langkah tiap algoritma berbeda?',
    answer: 'Setiap algoritma punya strategi sendiri. Jenis data juga berpengaruh, misalnya data yang hampir urut biasanya lebih mudah untuk algoritma adaptif.',
  },
  {
    question: 'Algoritma mana yang paling baik?',
    answer: 'Tidak ada satu algoritma yang selalu paling baik. Quick Sort cepat secara rata-rata, Merge Sort stabil dan konsisten, sedangkan Insertion Sort bagus untuk data kecil atau hampir urut.',
  },
  {
    question: 'Apakah pseudocode di sini sama dengan kode produksi?',
    answer: 'Pseudocode disederhanakan agar mudah dibaca. Implementasi nyata bisa memiliki optimasi tambahan, validasi, atau variasi strategi.',
  },
];

export function HelpPanel() {
  return (
    <section
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 320px), 1fr))',
        gap: 24,
      }}
    >
      <div style={{ backgroundColor: Colors.light.surface, border: `1px solid ${Colors.light.border}`, borderRadius: 8, padding: 20 }}>
        <h2 style={{ margin: '0 0 14px', color: Colors.light.primary, fontSize: 18 }}>Cara menggunakan</h2>
        <div style={{ display: 'grid', gap: 12 }}>
          {steps.map((step, index) => (
            <div key={step.title} style={{ display: 'grid', gridTemplateColumns: '28px 1fr', gap: 10 }}>
              <div
                style={{
                  width: 28,
                  height: 28,
                  borderRadius: 6,
                  backgroundColor: Colors.light.background,
                  border: `1px solid ${Colors.light.border}`,
                  color: Colors.light.primary,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: 12,
                  fontWeight: 700,
                }}
              >
                {index + 1}
              </div>
              <div>
                <div style={{ color: Colors.light.text, fontSize: 14, fontWeight: 700, marginBottom: 4 }}>{step.title}</div>
                <div style={{ color: Colors.light.textSecondary, fontSize: 13, lineHeight: 1.6 }}>{step.body}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div style={{ backgroundColor: Colors.light.surface, border: `1px solid ${Colors.light.border}`, borderRadius: 8, padding: 20 }}>
        <h2 style={{ margin: '0 0 14px', color: Colors.light.primary, fontSize: 18 }}>FAQ bantuan</h2>
        <div style={{ display: 'grid', gap: 8 }}>
          {faqs.map((item) => (
            <details
              key={item.question}
              style={{
                backgroundColor: Colors.light.background,
                border: `1px solid ${Colors.light.border}`,
                borderRadius: 6,
                padding: '10px 12px',
              }}
            >
              <summary style={{ color: Colors.light.text, cursor: 'pointer', fontSize: 13, fontWeight: 700 }}>
                {item.question}
              </summary>
              <p style={{ margin: '8px 0 0', color: Colors.light.textSecondary, fontSize: 13, lineHeight: 1.6 }}>
                {item.answer}
              </p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}
